export const FETCH_MATCH_DATA = 'FETCH_MATCH_DATA';
export const CREATE_LIVE_FOR_MATCH = 'CREATE_LIVE_FOR_MATCH';
export const FETCH_LIVE = 'FETCH_LIVE';
export const ADD_ACTION = 'ADD_ACTION';
export const DELETE_ACTION = 'DELETE_ACTION';
export const EDIT_ACTION = 'EDIT_ACTION';
export const CANCEL_LIVE = 'CANCEL_LIVE';
export const SUBSCRIBE = 'SUBSCRIBE';
export const SWITCH_PAGE = 'SWITCH_PAGE';
export const UPDATE_LIVE_ON_MATCH_DATA = 'UPDATE_LIVE_ON_MATCH_DATA';
export const DELETE_LIVE_ON_MATCH_DATA = 'DELETE_LIVE_ON_MATCH_DATA';
export const WORKER_CANCEL_LIVE = 'WORKER_CANCEL_LIVE';
export const WORKER_CANCEL_LIVE_ON_MATCH_DATA = 'WORKER_CANCEL_LIVE_ON_MATCH_DATA';
export const SCORE = 'SCORE';
export const INITIALIZE_CONNEXION = 'INITIALIZE_CONNEXION';
export const UNSUBSCRIBE_LIVE = 'UNSUBSCRIBE_LIVE';
export const HALFTIME = 'HALFTIME';
export const FIRST_PERIOD = 'FIRST_PERIOD';
export const SECOND_PERIOD = 'SECOND_PERIOD';
export const END_LIVE = 'END_LIVE';
export const RESET_DEMO = 'RESET_DEMO';
export const FIRST_PERIOD_PROLONGATION = 'FIRST_PERIOD_PROLONGATION';
export const SECOND_PERIOD_PROLONGATION = 'SECOND_PERIOD_PROLONGATION';
export const HALFTIME_PROLONGATION = 'HALFTIME_PROLONGATION';